import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=8947216c&"
import script from "./UserProfilePage.vue?vue&type=script&lang=js&"
export * from "./UserProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports